import type { Context } from '../../checkout.machine.types';

export const isReactivation = (context: Context): boolean =>
  context.hasCancelledSubscription && context.hasFairDowngrade;

export const isSubscriptionOverdue = (context: Context): boolean => context.hasOverdueSubscription;
